import { render, staticRenderFns } from "./ModulesTab.vue?vue&type=template&id=6fd1d086&scoped=true&"
import script from "./ModulesTab.vue?vue&type=script&lang=js&"
export * from "./ModulesTab.vue?vue&type=script&lang=js&"
import style0 from "./ModulesTab.vue?vue&type=style&index=0&id=6fd1d086&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd1d086",
  null
  
)

component.options.__file = "ModulesTab.vue"
export default component.exports